/* FG continuous scroll for collection grids. Falls back to normal pagination without JS. */
(() => {
  if (customElements.get('fg-infinite-scroll')) return;
  class FgInfiniteScroll extends HTMLElement {
    connectedCallback() {
      this.nav = this.parentElement && this.parentElement.querySelector('nav.pagination');
      if (this.nav) this.nav.style.display = 'none';
      this.io = new IntersectionObserver((e) => { if (e[0].isIntersecting) this.load(); }, { rootMargin: '900px 0px' });
      this.io.observe(this);
    }
    disconnectedCallback() { if (this.io) this.io.disconnect(); }
    async load() {
      if (this.busy || !this.dataset.next) return;
      this.busy = true; this.classList.add('is-loading');
      try {
        const u = new URL(this.dataset.next, location.origin);
        u.searchParams.set('section_id', this.dataset.section);
        const res = await fetch(u.toString(), { credentials: 'same-origin' });
        if (!res.ok) throw new Error(res.status);
        const doc = new DOMParser().parseFromString(await res.text(), 'text/html');
        const list = document.getElementById(this.dataset.list);
        const incoming = doc.getElementById(this.dataset.list);
        if (list && incoming) {
          [...incoming.children].forEach((c) => {
            c.removeAttribute('reveal-on-scroll');
            list.appendChild(document.importNode(c, true));
          });
        }
        const nx = doc.querySelector('fg-infinite-scroll');
        if (nx && nx.dataset.next) {
          this.dataset.next = nx.dataset.next;
          this.busy = false; this.classList.remove('is-loading');
          if (this.getBoundingClientRect().top < innerHeight + 900) this.load();
        } else {
          this.io.disconnect(); this.remove();
        }
      } catch (err) {
        this.busy = false; this.classList.remove('is-loading');
        if (this.nav) this.nav.style.display = '';
        this.io.disconnect();
      }
    }
  }
  customElements.define('fg-infinite-scroll', FgInfiniteScroll);
})();
